module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "overlay d-flex flex-column align-items-center justify-content-center",
    class: _vm.promptClass
  }, [_c('div', {
    staticClass: "promptHolder py-3 px-5 radius-normal darker"
  }, [_c(_vm.selectedTemplate, {
    tag: "div",
    attrs: {
      "info": _vm.getRichPromptServerInfo
    },
    on: {
      "clickedOk": _vm.clickedOk,
      "clickedCancel": _vm.clickedCancel
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6b086c78", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b086c78"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/richPrompt/richPrompt.vue
// module id = 2505
// module chunks = 0